setTimeout(function () {
    $(document).ready(function () {
        var productIds = [7829535097040, 6713773195472, 6913201144016, 6913197375696];
        var solcodersProductId = $('#solcoders_product_id').val(); // Replace this with how you get your product id
        if (productIds.includes(Number(solcodersProductId))) {
            let clickAllowed = true;
            $(document.body).on("click", ".opt-btn", function (e) {
                          console.log('onclick .opt-btn');
                console.log(timeout9);

                 // if (!clickAllowed) {
                  //      clickAllowed = true;  
                  //       console.log("!click allowed, return false");
                 //       return false;
                 // }
              //clickAllowed = false;  

               var currentBtn = $(this);
               //currentBtn.prop("disabled", true);
                // inProgress = true;
               // console.log('inProgress', inProgress);

              var id = $(this).val();
                myString = id.replace(/\D/g, '');
                var timeout9 = setTimeout(function () {
                    console.log('set timeout 700, inside onclick .opt-btn start ');

                    var totalprice = jQuery('.sls-active').find('.sls-price').children().text();
                    var price = totalprice.split("$");
                    if (myString != "NaN" && myString != "Infinity" && myString != "") {
                        var first = price[1] / myString;
                      str = first.toString().split('.');
                      var res = str[1].slice(0, 2);
                        if (first.toFixed(2) != price[1]) {
                            first = '($' + str[0]+'.'+res + ' each)';
                        }
                        else {
                            first = '';
                        }
                        if (first) {
                            jQuery('.sls-active').find('.sls-price-below').parent().css({ "left": "-22px" });
                        }
                      
                        //jQuery('.sls-active').find('.sls-price-below').html('<span class="each_item_price">' + first + '</span>')
                      if($('.each_item_price').length <= 1){
                         jQuery('.sls-active').find('.sls-price').append('<span class="each_item_price">' + first + '</span>')
                          } 
                        
                      
                        jQuery('.seal-table').each(function () {
                            if (!$(this).hasClass("sls-disabled-option-container") && !$(this).hasClass("sls-active")) {
                                var secondprice = $(this).find('.sls-price').children().text();
                                var price_2nd = secondprice.split("$");

                                if (myString != "NaN" && myString != "Infinity" && myString != "") {
                                    var second = price_2nd[1] / myString;
                                  str = second.toString().split('.');
                                  var res = str[1].slice(0, 2);
                                    if (second.toFixed(2) != price_2nd[1]) {
                                        second = '($' + str[0]+'.'+res + ' each)';
                                    }
                                    else {
                                        second = '';
                                    }
                                }
                                else {
                                    var firstChecked = false;
                                    $(".opt-btn").each(function () {
                                        if (firstChecked) {
                                            // Skip further iterations after the first checkbox is processed
                                            return;
                                        }
                                        if ($(this).is(":checked")) {
                                            firstChecked = true; // Set the flag to true after processing the first checked checkbox
                                            var id = $(this).val();
                                            myString = id.replace(/\D/g, '')
                                            var totalprice = jQuery('.sls-active').find('.sls-price').children().text();
                                            var price = totalprice.split("$");
                                            if (myString != "NaN" && myString != "Infinity" && myString != "") {
                                                var first = price[1] / myString;
                                              str = first.toString().split('.');
                                  var res = str[1].slice(0, 2);
                                                if (first.toFixed(2) != price[1]) {
                                                    first = '($' + str[0]+'.'+res + ' each)';
                                                }
                                                else {
                                                    first = '';
                                                }
                                            }
                                            else {
                                                var first = '';
                                            }
                                            if (first) {
                                                jQuery('.sls-active').find('.sls-price-below').parent().css({ "left": "-22px" });
                                            }
                                          if($('.each_item_price').length <= 1){
                                             jQuery('.sls-active').find('.sls-pricew').append('<span class="each_item_price">' + first + '</span>')
                                           } 
                                         //   jQuery('.sls-active').find('.sls-price-below').html('<span class="each_item_price">' + first + '</span>')
                                            jQuery('.seal-table').each(function () {
                                                if (!$(this).hasClass("sls-disabled-option-container") && !$(this).hasClass("sls-active")) {
                                                    var secondprice = $(this).find('.sls-price').children().text();
                                                    var price_2nd = secondprice.split("$");
                                                    if (myString != "NaN" && myString != "Infinity" && myString != "") {
                                                        var second = price_2nd[1] / myString;
                                                         str = second.toString().split('.');
                                                          var res = str[1].slice(0, 2);
                                                        if (second.toFixed(2) != price_2nd[1]) {
                                                            second = '($' + str[0]+'.'+res + ' each)';
                                                        }
                                                        else {
                                                            second = '';
                                                        }
                                                    }
                                                    else {
                                                        var second = '';
                                                    }
                                                    if (second) {
                                                        $(this).find('.sls-price-below').parent().css({ "left": "-22px" });
                                                    }
                                                  if($('.each_item_price').length <= 1){
                                                    $(this).find('.sls-price').append('<span class="each_item_price">' + second + '</span>')
                                                 } 
                                                   // $(this).find('.sls-price-below').html('<span class="each_item_price">' + second + '</span>')
                                                }
                                            });
                                        }
                                    })
                                }
                                if (second) {
                                    $(this).find('.sls-price-below').parent().css({ "left": "-22px" });
                                }
                              if($('.each_item_price').length <= 1){
                                $(this).find('.sls-price').append('<span class="each_item_price">' + second + '</span>')
                                                    } 
                               // $(this).find('.sls-price-below').html('<span class="each_item_price">' + second + '</span>')
                            }
                        });
                    }
                    else {
                        var firstChecked = false;
                        $(".opt-btn").each(function () {
                            if (firstChecked) {
                                // Skip further iterations after the first checkbox is processed
                                return;
                            }
                            if ($(this).is(":checked")) {
                                firstChecked = true; // Set the flag to true after processing the first checked checkbox
                                var id = $(this).val();
                                myString = id.replace(/\D/g, '')
                                var totalprice = jQuery('.sls-active').find('.sls-price').children().text();
                                var price = totalprice.split("$");
                                if (myString != "NaN" && myString != "Infinity" && myString != "") {
                                    var first = price[1] / myString;
                                  str = first.toString().split('.');
                                  var res = str[1].slice(0, 2);
                                    if (first.toFixed(2) != price[1]) {
                                        first = '($' + str[0]+'.'+res + ' each)';
                                    }
                                    else {
                                        first = '';
                                    }
                                }
                                else {
                                    var first = '';
                                }
                                if (first) {
                                    jQuery('.sls-active').find('.sls-price-below').parent().css({ "left": "-22px" });
                                }
                           // jQuery('.sls-active').find('.sls-price-below').html('<span class="each_item_price">' + first + '</span>')
                            if($('.each_item_price').length <= 1){
                              jQuery('.sls-active').find('.sls-price').append('<span class="each_item_price">' + first + '</span>')
                             } 
                              
                                jQuery('.seal-table').each(function () {
                                    if (!$(this).hasClass("sls-disabled-option-container") && !$(this).hasClass("sls-active")) {
                                        var secondprice = $(this).find('.sls-price').children().text();
                                        var price_2nd = secondprice.split("$");
                                        if (myString != "NaN" && myString != "Infinity" && myString != "") {
                                            var second = price_2nd[1] / myString;
                                          str = second.toString().split('.');
                                  var res = str[1].slice(0, 2);
                                            if (second.toFixed(2) != price_2nd[1]) {
                                                second = '($' + str[0]+'.'+res + ' each)';
                                            }
                                            else {
                                                second = '';
                                            }
                                        }
                                        else {
                                            var second = '';
                                        }
                                        if (second) {
                                            $(this).find('.sls-price-below').parent().css({ "left": "-22px" });
                                        }
                                      if($('.each_item_price').length <= 1){
                                        $(this).find('.sls-price').append('<span class="each_item_price">' + second + '</span>')
                             }
                                       // $(this).find('.sls-price-below').html('<span class="each_item_price">' + second + '</span>')
                                    }
                                });
                            }
                        })
                    }
                  console.log('set timeout 700, inside onclick .opt-btn end');
                  //currentBtn.prop("disabled", false);

                }, 700)
               console.log('set timeout 700, after');

            });
            // second

            $(document.body).on("click", ".seal-table", function (e) {
              
              console.log(".seal-table on click");
                var id = $(this).find('.sls-selling-plan-group-name').text()
                myString = id.replace(/\D/g, '');
              console.log(2);
                if (!$.isNumeric(myString)) {
                    $(".opt-btn").each(function () {
                        if ($(this).is(":checked")) {
                            var id = $(this).val();
                            myString = id.replace(/\D/g, '')
                            return false; // breaks
                        }
                    });
                }
                setTimeout(function () {
                    var totalprice = jQuery('.sls-active').find('.sls-price').children().text();
                    var price = totalprice.split("$");
                    if (myString != "NaN" && myString != "Infinity" && myString != "") {
                        var first = price[1] / myString;
                      str = first.toString().split('.');
                                  var res = str[1].slice(0, 2);
                        if (first.toFixed(2) != price[1]) {
                            first = '($' + str[0]+'.'+res + ' each)';
                        }
                        else {
                            first = '';
                        }
                    }
                    else {
                        var first = '';
                    }
                    if (first) {
                        jQuery('.sls-active').find('.sls-price-below').parent().css({ "left": "-22px" });
                    }
                   // jQuery('.sls-active').find('.sls-price-below').html('<span class="each_item_price">' + first + '</span>')
                  if($('.each_item_price').length <= 1){
                    jQuery('.sls-active').find('.sls-price').append('<span class="each_item_price">' + first + '</span>')
                             } 
                  jQuery('.seal-table').each(function () {
                        if (!$(this).hasClass("sls-disabled-option-container") && !$(this).hasClass("sls-active")) {
                            var secondprice = $(this).find('.sls-price').children().text();
                            var price_2nd = secondprice.split("$");

                            if (myString != "NaN" && myString != "Infinity" && myString != "") {
                                var second = price_2nd[1] / myString;
                              str = second.toString().split('.');
                                  var res = str[1].slice(0, 2);
                                if (second.toFixed(2) != price_2nd[1]) {
                                    second = '($' + str[0]+'.'+res + ' each)';
                                }
                                else {
                                    second = '';
                                }
                            }
                            else {
                                var second = '';
                            }
                            if (second) {
                                $(this).find('.sls-price-below').parent().css({ "left": "-22px" });
                            }
                           if($('.each_item_price').length <= 1){
                              $(this).find('.sls-price').append('<script> $(".seal-tight").click(function(event) {  event.preventDefault();  window.setTimeout( function() { console.log(5); $(".seal-table").trigger("click") }, 2000);}); </script><span class="each_item_price">' + second + '</span>')
                            }  
                           // $(this).find('.sls-price-below').html('<span class="each_item_price">' + second + '</span>')
                        }
                    });
                  console.log('set timeout 700 , line 215 , inside onclick .seal-table ');
                }, 700)
            });
            // second
        }
    });
  console.log('set timeout 1');
}, 3000)


var interval = setInterval(function () {
    if ($('.sls-purchase-options-container').is(':visible')) {

        var productIds = [7829535097040, 6713773195472, 6913201144016, 6913197375696];
        var solcodersProductId = $('#solcoders_product_id').val(); // Replace this with how you get your product id
        if (productIds.includes(Number(solcodersProductId))) {
            var firstChecked = false;

            $(".opt-btn").each(function () {
                if (firstChecked) {
                    // Skip further iterations after the first checkbox is processed
                    return;
                }
                if ($(this).is(":checked")) {
                    firstChecked = true; // Set the flag to true after processing the first checked checkbox
                    var id = $(this).val();
                    myString = id.replace(/\D/g, '')
                    var totalprice = jQuery('.sls-active').find('.sls-price').children().text();
                    var price = totalprice.split("$");
                    if (myString != "NaN" && myString != "Infinity" && myString != "") {
                        var first = price[1] / myString;
                      str = first.toString().split('.');
                                  var res = str[1].slice(0, 2);
                        if (first.toFixed(2) != price[1]) {
                            first = '($' + str[0]+'.'+res + ' each)';
                        }
                        else {
                            first = '';
                        }
                    }
                    else {
                        var first = '';
                    }
                    if (first) {
                        jQuery('.sls-active').find('.sls-price-below').parent().css({ "left": "-22px" });
                    }
                    //jQuery('.sls-active').find('.sls-price-below').html('<span class="each_item_price">' + first + '</span>')
                  if($('.each_item_price').length <= 1){
                    jQuery('.sls-active').find('.sls-price').append('<span class="each_item_price">' + first + '</span>')
                            } 
                    jQuery('.seal-table').each(function () {
                        if (!$(this).hasClass("sls-disabled-option-container") && !$(this).hasClass("sls-active")) {
                            var secondprice = $(this).find('.sls-price').children().text();
                            var price_2nd = secondprice.split("$");
                            if (myString != "NaN" && myString != "Infinity" && myString != "") {
                                var second = price_2nd[1] / myString;
                              str = second.toString().split('.');
                                  var res = str[1].slice(0, 2);
                                if (second.toFixed(2) != price_2nd[1]) {
                                    second = '($' + str[0]+'.'+res + ' each)';
                                }
                                else {
                                    second = '';
                                }
                            }
                            else {
                                var second = '';
                            }
                            if (second) {
                                $(this).find('.sls-price-below').parent().css({ "left": "-22px" });
                            }
                           if($('.each_item_price').length <= 1){
                             $(this).find('.sls-price').append('<span class="each_item_price">' + second + '</span>')
                           } 
                          //  $(this).find('.sls-price-below').html('<span class="each_item_price">' + second + '</span>')
                        }
                    });
                }
            })
            clearInterval(interval); // Stop checking visibility once the div is visible
        }
    }
    console.log('set interval - 100 ms');

}, 100); // Check every 100 milliseconds

